import { showExcept, showWhenAnyOf } from "./route-helpers";

export const applications = [
  {
    name: "@bsp/header",
    app: () => System.import("@bsp/header"),
    activeWhen: showExcept(["/login", "/landing"]),
  },
  // {
  //   name: "@bsp/sidebar",
  //   app: () => System.import("@bsp/sidebar"),
  //   activeWhen: showExcept(["/login"]),
  // },
  {
    name: "@bsp/login",
    app: () => System.import("@bsp/login"),
    activeWhen: ["/login"],
  },
  {
    name: "@bsp/analise",
    app: () => System.import("@bsp/analise"),
    activeWhen: ["/analise"],
  },
  {
    name: "@bsp/documents",
    app: () => System.import("@bsp/documents"),
    activeWhen: ["/documento", "/login/banrisul", "/configuracoes", "/usuarios"],
  },
  {
    name: "@bsp/landing",
    app: () => System.import("@bsp/landing"),
    activeWhen: ["/landing"],
  },
];
